import React from 'react';
import { Row, Col } from 'antd';
import DualAxisChart from '../../../../../shared/charts/DualAxisChart';
import { summaryScale } from '../../utils/summaryScale';
import moment from 'moment';
import DetailBar from './components/DetailBar';
import SessionsTable from './components/SessionsTable';
import SessionDeviceBreakdown from './components/SessionDeviceBreakdown';
import { LoadingPage } from '../../../../../shared/LoadingPage';

const SessionsTabView = ({
  campaignOrder,
  summaryData,
  formattedByDate,
  formattedSessions,
  filteredByDateBreakdown,
  sessionsTotal,
  loading,
  sessionsLoading,
  reportDataSummaryLoading,
  changeDatePicker,
  fetchSessionDetails,
  expandedRowsData,
  setExpandedRowsData,
  sessionDetailsLoading,
}) => {
  document.title = `Sessions - ${campaignOrder.name}`;

  const dropDownOptions = [
    { key: 'sessions', display: 'Sessions' },
    { key: 'impressions', display: 'Impressions' },
  ];

  if (reportDataSummaryLoading) return <LoadingPage />;

  return (
    <>
      <DetailBar
        sessions={summaryData?.sessions}
        averageSessionDuration={summaryData?.averageSessionDuration}
        pagesPerSession={summaryData?.pagesPerSession}
        startDate={campaignOrder.startDate}
        endDate={campaignOrder.endDate}
        loading={loading}
      />
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <DualAxisChart
            byDate={formattedByDate || []}
            xAxis="date"
            options={dropDownOptions}
            defaultLeftYValue={dropDownOptions[0]}
            defaultRightYValue={dropDownOptions[1]}
            customScale={summaryScale}
            onDatePickerChange={({ dates, rangeKey }) => {
              if (changeDatePicker) {
                changeDatePicker(dates);
              }
            }}
            disabled={!formattedByDate || formattedByDate.length === 0}
            has6MonDisables={false}
            allTimeDateRange={[moment(campaignOrder.startDate), moment(campaignOrder.endDate)]}
          />
        </Col>
        <Col span={24}>
          <SessionDeviceBreakdown
            data={filteredByDateBreakdown || []}
          />
        </Col>
        <Col xs={24}>
          <SessionsTable
            data={formattedSessions || []}
            total={sessionsTotal}
            loading={sessionsLoading}
            fetchSessionDetails={fetchSessionDetails}
            expandedRowsData={expandedRowsData}
            setExpandedRowsData={setExpandedRowsData}
            sessionDetailsLoading={sessionDetailsLoading}
          />
        </Col>
      </Row>
    </>
  );
};

export default SessionsTabView;
